import React from 'react';

const Products = () => {
  const products = [
    {
      name: 'PhenoLeap',
      subtitle: '基于大语言模型的表型转换工具',
      description: '利用先进的大语言模型技术，实现临床表型描述与标准化表型本体的智能转换，提高临床数据的标准化程度和可用性。',
      features: [
        '智能表型识别与转换',
        '多语言支持',
        '高精度匹配算法',
        'API接口集成'
      ],
      tags: ['AI驱动', '表型分析', 'NLP'],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    },
    {
      name: 'ShinyCellX',
      subtitle: '单细胞可视化与交互分析平台',
      description: '基于Shiny框架开发的交互式单细胞数据分析平台，提供直观的可视化界面和强大的分析功能，让单细胞数据分析变得简单高效。',
      features: [
        '交互式数据可视化',
        '多种降维算法',
        '细胞类型注释',
        '差异表达分析'
      ],
      tags: ['单细胞', '可视化', '交互式'],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
        </svg>
      )
    }
  ];

  return (
    <section id="products" className="bg-gray-50 section-padding">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            创新软件产品
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我们开发的专业生物信息学软件工具，助力科研工作者提升研究效率
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid lg:grid-cols-2 gap-12">
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              {/* Product Image */}
              <div className="h-64 relative overflow-hidden">
                <img
                  src={index === 0 ? "/PhenoLeap.png" :
                    "/ShinyCellX.png"}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />

                {/* Tags */}
                <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                  {product.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="bg-gray-600 text-white text-xs font-medium px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Product Content */}
              <div className="p-8">
                <div className="mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {product.name}
                  </h3>
                  <p className="text-primary-600 font-medium mb-4">
                    {product.subtitle}
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    {product.description}
                  </p>
                </div>

                {/* Features */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-900 mb-3">核心功能：</h4>
                  <ul className="grid grid-cols-2 gap-2">
                    {product.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                        <svg className="w-4 h-4 text-primary-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    className="btn-primary flex-1"
                    onClick={() => {
                      const url = product.name === 'PhenoLeap'
                        ? 'https://biozen.top/phenoleap/'
                        : 'https://biozen.top/scdata_platform';
                      window.open(url, '_blank');
                    }}
                  >
                    立即试用
                  </button>
                  <button
                    className="btn-secondary flex-1"
                    onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    了解更多
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-primary-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">需要定制化解决方案？</h3>
            <p className="text-primary-100 mb-6 max-w-2xl mx-auto">
              我们可以根据您的具体需求开发专属的生物信息学软件工具
            </p>
            <button
              className="bg-white text-primary-600 hover:bg-gray-100 font-medium py-3 px-8 rounded-lg transition-colors duration-200"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              联系我们讨论
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;